import {Injectable, ViewContainerRef} from '@angular/core';

@Injectable()
export class InjectionsService {
    private _viewContainerRef: ViewContainerRef;

    /**
     * Returns the ViewContainerRef of the Injections point in the
     * Document Object Model
     */
    public get(): ViewContainerRef {
        return this._viewContainerRef;
    }

    /**
     *
     * @param viewContainerRef
     */
    public post(viewContainerRef: ViewContainerRef): void {
        this._viewContainerRef = viewContainerRef;
    }
}
